export default __webpack_public_path__ + "static/media/coinLogoWithTextRed.5701980e.png";